import useGrantablePermissions from './useGrantablePermissions';
import useIsDataPermissionsEnabled from './useIsDataPermissionsEnabled';
import PERMISSIONS from '../../permissionDefinitions';
import { useMemo } from 'react';

// What permissions should be enabled by default?
// This is a different concern from which ones can be granted.
const useDefaultPermissions = () => {
  const isDataPermissionsEnabled = useIsDataPermissionsEnabled();
  const { configPermissions } = useGrantablePermissions({
    isUserShowScreen: false,
  });

  const defaultPermissions = useMemo(() => {
    if (isDataPermissionsEnabled) {
      return configPermissions
        .filter((p) => p.isEnabledByDefault)
        .map((p) => p.permission);
    }

    return [
      ...configPermissions,
      {
        permission: PERMISSIONS.VIEW_DATA.VIEW_REVENUE,
        isEnabledByDefault: true,
      },
      {
        permission: PERMISSIONS.VIEW_DATA.VIEW_ACCIDENTS,
        isEnabledByDefault: true,
      },
    ]
      .filter((p) => p.isEnabledByDefault)
      .map((p) => p.permission);
  }, [configPermissions, isDataPermissionsEnabled]);

  return defaultPermissions;
};

export default useDefaultPermissions;
